// History — past stumbles. Scrollable list per docs/UI_SPEC.md.

import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { type NightDetailsDto, meApi } from '../api'
import { TopBar } from '../components/TopBar'

export const Route = createFileRoute('/history')({
  component: HistoryRoute,
})

function HistoryRoute() {
  const navigate = useNavigate()
  const [nights, setNights] = useState<NightDetailsDto[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    void (async () => {
      try {
        const data = await meApi.history()
        setNights(data)
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  return (
    <div className="stumble-screen">
      <TopBar eyebrow="your nights" title="recap" />
      <div className="screen-body with-nav" style={{ display: 'grid', gap: 8 }}>
        {loading && (
          <div className="card body-sm muted" style={{ textAlign: 'center' }}>
            loading…
          </div>
        )}
        {!loading && nights.length === 0 && (
          <div
            className="card"
            data-testid="history-empty"
            style={{ textAlign: 'center', padding: 22, display: 'grid', gap: 10 }}
          >
            <p className="display" style={{ fontSize: 32, margin: 0 }}>
              Your first stumble awaits.
            </p>
            <p className="body-sm muted" style={{ margin: 0 }}>
              Tap START to begin tracking tonight.
            </p>
            <button
              type="button"
              className="btn full"
              onClick={() => navigate({ to: '/' })}
              style={{
                marginTop: 6,
                background: 'var(--acid, var(--lime))',
                color: 'var(--ink)',
                fontFamily: 'var(--font-display)',
                fontSize: 22,
                padding: '14px 16px',
                border: '2.5px solid var(--line)',
                borderRadius: 16,
                boxShadow: '0 5px 0 var(--shadow-ink)',
              }}
            >
              START A STUMBLE
            </button>
          </div>
        )}
        <div className="scroll-region" style={{ display: 'grid', gap: 8 }}>
          {nights.map((n) => {
            const startedAt = new Date(n.night.startedAt)
            return (
              <button
                type="button"
                key={n.night.id}
                onClick={() => navigate({ to: '/night/$id/recap', params: { id: n.night.id } })}
                className="card"
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr auto',
                  gap: 6,
                  textAlign: 'left',
                }}
              >
                <div style={{ minWidth: 0 }}>
                  <div
                    style={{
                      fontFamily: 'var(--font-display)',
                      fontSize: 24,
                      textTransform: 'lowercase',
                      lineHeight: 1,
                    }}
                  >
                    {startedAt.toLocaleDateString()}
                  </div>
                  <div className="body-sm muted" style={{ fontSize: 12, marginTop: 4 }}>
                    {n.totals.drinks} drinks · {n.totals.venues} venues
                  </div>
                </div>
                <div className="display" style={{ fontSize: 32, alignSelf: 'center' }}>
                  →
                </div>
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}
